module.exports = __webpack_public_path__ + "img/background2.3105e8d4.png";